import { Avatar, Box, Paper, Typography } from "@mui/material";
import { ReactNode } from "react";

interface CardProps {
  icone: JSX.Element
  titulo: ReactNode
  valor: ReactNode
  bgColor: string
  esconder?: boolean
}

export function Card({ icone: Icone, titulo, valor, bgColor, esconder = false }: CardProps){
  if (esconder) return <></>
  return (
    <Paper elevation={2}>
      <Box height={"100px"} width={"275px"} padding={"16px"}>
        <Box display={"flex"} alignItems={"center"} height={"100%"} width={"100%"}>
          <Avatar style={{ backgroundColor: bgColor }}>
            {Icone}
          </Avatar>
          <Box flex={1} marginLeft={2} display={"flex"} alignItems={"flex-start"} flexDirection={"column"} height={"100%"} justifyContent={"space-between"}>
            <Typography align="left" variant="body1">{titulo}</Typography>
            <Typography variant="body2" color="textSecondary">{valor}</Typography>
          </Box>
        </Box>
      </Box>
    </Paper>
  )
}